import React, {Component} from 'react';
import {func} from 'prop-types';
import {mapObjIndexed, values} from 'ramda';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import cx from 'classnames';
import s from './Profile.css';
import {getEHNACPasswordRequirements, validateEHNACPassword} from "../../../../lib/PasswordUtils";

export default class ChangePassword extends Component {
  static propTypes = {
    updatePassword: func,
    updateValue: func,
  };

  constructor(props) {
    super(props);

    this.state = ({
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      misMatchError: false,
      validPasswordError: false,
      showDialog: false,
      labels: {
        currentPassword: 'Current password',
        newPassword: 'New password',
        confirmNewPassword: 'Confirm new password',
      },
    });
  }


  validatePassword = () => {
    if (this.state.newPassword !== this.state.confirmNewPassword) {
      this.setState({
        misMatchError: true,
      });
    } else if (!validateEHNACPassword(this.state.newPassword)){
      this.setState({
        misMatchError: false,
        validPasswordError: true,
      });
    } else {

      this.setState({
        misMatchError: false,
        validPasswordError: false,
      });
      return true;
    }
  };

  handleSubmit(e) {
    e.preventDefault();

    const { currentPassword, newPassword } = this.state;

    if (this.validatePassword()) {

      this.props.updatePassword({ currentPassword, newPassword }, this.handleRequestClose());

    }
  }

  handleRequestClose = () => {
    this.setState({
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      misMatchError: false,
      validPasswordError: false,
      showDialog: false,
    });
  };

  render = () => {
    const { currentPassword, newPassword, confirmNewPassword } = this.state;

    const dialogActions = [
      <FlatButton
        id="cancelPasswordUpdate"
        label="Cancel"
        primary={true}
        onClick={this.handleRequestClose}
      />,
      <FlatButton
        id="submitPasswordUpdate"
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={e => this.handleSubmit(e)}
        disabled={!currentPassword || !newPassword || !confirmNewPassword}
      />,
    ];

    return (
      <section className={s.group}>
        <label className={s.label} htmlFor="editPassword">
          Password
        </label>
        <div className={s.controlContainer}>
          <button
            id="editPassword"
            type="button"
            className={s.btn}
            onClick={() => this.setState({ showDialog: true })}
          >
            Edit password
          </button>
          <Dialog
            id="changePasswordDialog"
            open={this.state.showDialog}
            title="Change Password"
            actions={dialogActions}
            onRequestClose={() => this.handleRequestClose()}
            contentClassName={s.dialog}
            titleClassName={s.dialogTitle}
            overlayClassName={s.dialogOverlay}
          >
            <p className={s.helpText}>
              {getEHNACPasswordRequirements()}
            </p>
            <form onSubmit={this.handleSubmit}>
              {values(mapObjIndexed((field, key) =>
                <div className={s.group} key={key}>
                  <label className={s.label} htmlFor={`${key}__password`}>
                    {this.state.labels[key]}
                  </label>
                  <div className={s.controlContainer}>
                    <input
                      required
                      className={s.control}
                      id={`${key}__password`}
                      name={`${key}__password`}
                      type="password"
                      value={field}
                      ref={(input) => { this[key + "ref"] = input }}
                      onChange={event => this.setState({ [key]: event.target.value })}
                    />
                  </div>
                </div>, { currentPassword, newPassword, confirmNewPassword }))}
            </form>

            {this.state.misMatchError &&
              <div className={cx(s.margins, s.helpText)}>
                New and Confirm Password fields do not match. Please try again.
              </div>
            }

            {this.state.validPasswordError &&
              <div className={cx(s.margins, s.helpText)}>
                Your password isn&rsquo;t strong enough. Please review the password requirements and try again.
              </div>
            }
          </Dialog>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Account/Profile/ChangePassword.js